const Loading = ({ text = 'Memuat data...' }) => (
  <div className="loading-state">
    <div className="loading-state__spinner" />
    <p className="loading-state__text">{text}</p>
  </div>
);

export default Loading;
